import moment from 'moment';
import { forwardRef } from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import { Control, useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt } from 'react-icons/fa';
import { DATE_FORMAT_YYYY_MM_DD } from 'utils';
import { SearchFairTopListFilter } from '../models';

interface FormSearchValues {
  target_date: Date;
}

export interface FairTopListFilterProps {
  onFilter?: (data: SearchFairTopListFilter) => void;
}

function FairTopListFilter({ onFilter }: FairTopListFilterProps) {
  const { t } = useTranslation();

  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    formState: { isSubmitting },
  } = useForm<FormSearchValues>({
    defaultValues: {
      target_date: new Date(),
    },
  });

  const watchTargetDate = useWatch({
    control,
    name: 'target_date',
    defaultValue: getValues('target_date'),
  });

  // events
  function handleSearchSubmit(data: FormSearchValues) {
    const filterPayload: SearchFairTopListFilter = {
      targetDate: data.target_date,
    };

    onFilter?.(filterPayload);
  }

  return (
    <Accordion className="mb-3" defaultActiveKey={['0', '1', '2']} alwaysOpen>
      <Accordion.Item eventKey="0" className="movement-information">
        <Accordion.Header>{t('MenuList.Filter.filter_condition')} </Accordion.Header>
        <Accordion.Body>
          <Form onSubmit={handleSubmit(handleSearchSubmit)}>
            <div className="d-flex h-100 flex-column justify-content-between">
              <div>
                <div className="mb-2">
                  <Form.Label htmlFor="cbo-status-data" className="col-form-label">
                    {t('FairTopListPage.expired_date')}：{t('FairTopListPage.expired_date_description')}
                  </Form.Label>

                  <div style={{ maxWidth: '160px' }}>
                    <ReactDatePicker
                      locale="ja"
                      selected={watchTargetDate}
                      onChange={(date: Date) => {
                        setValue('target_date', date);
                      }}
                      customInput={<CustomInputDatePicker readonly />}
                      dateFormat="yyyy/MM/dd"
                    />
                  </div>
                </div>
              </div>
              <div className="text-center">
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {t('MenuList.Filter.btn_search')}
                </button>
              </div>
            </div>
          </Form>
        </Accordion.Body>
        <div className="accordion-body accordion-summary">
          <Row>
            <TargetDatePreview control={control} />
          </Row>
        </div>
      </Accordion.Item>
    </Accordion>
  );
}

function TargetDatePreview({ control }: { control: Control<FormSearchValues, any> }) {
  const { t } = useTranslation();
  const targetDate = useWatch({ control, name: 'target_date' });

  return (
    <Col sm={'auto'}>
      <Form.Label className="col-form-label">{t('FairTopListPage.expired_date')}：</Form.Label>
      <Form.Label className="col-form-label">{moment(targetDate).format(DATE_FORMAT_YYYY_MM_DD)}</Form.Label>
    </Col>
  );
}

const CustomInputDatePicker = forwardRef((props: any, ref: any) => {
  // You can style this further
  return (
    <>
      <div style={{ position: 'relative' }}>
        <FaCalendarAlt style={{ position: 'absolute', top: '8px', left: '10px' }} onClick={props.onClick} />
        <input
          className="form-control text-center"
          onClick={props.onClick}
          style={{ paddingLeft: '32px' }}
          value={props.value}
          onChange={props.onChange}
          type="text"
          readOnly={props.readonly}
        />
      </div>
    </>
  );
});

export default FairTopListFilter;
